// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1EBvI","buttons":"RemoveExpirationActionButtons_buttons__2USD-"};